import { from } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ValidationObserver } from 'vee-validate';
import '../plugins/vee-validate';

const formMixin = {
  components: {
    ValidationObserver,
  },
  methods: {
    validate(options = null) {
      return from(this.$refs.form.validate()).pipe(
        tap((success) => {
          if (!success && options && options.isScrollToTopIfFail) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }),
        filter((success) => success),
      );
    },
  },
};

export default formMixin;
